import { render, staticRenderFns } from "./FooterIcons.vue?vue&type=template&id=0dc70ae0&"
import script from "./FooterIcons.vue?vue&type=script&lang=js&"
export * from "./FooterIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports